<template>
  <div>
    <h3>
      Efter Coding Class-forløbet må du meget gerne udfylde vores
      spørgeskema,<br />
      så vi kan gøre Coding Class endnu bedre i fremtiden.<br />
      <br />
      Herunder skal du vælge om du er elev eller lærer:
    </h3>
    <ul class="iam">
      <li>
        <a @click="showKind = 'elev'" :class="{ active: showKind == 'elev' }"
          >Elev</a
        >
      </li>
      <li>
        <a @click="showKind = 'lærer'" :class="{ active: showKind == 'lærer' }"
          >Lærer</a
        >
      </li>
    </ul>

    <div>
      <iframe
        v-if="showKind != 'none'"
        :src="getForm.url"
        width="640"
        :height="getForm.height"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        >Indlæser…</iframe
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Evaluering",
  data() {
    return {
      showKind: "none"
    };
  },
  computed: {
    getForm() {
      switch (this.showKind) {
        case "elev":
          return {
            height: 3510,
            url:
              "https://docs.google.com/forms/d/e/1FAIpQLSfkjAhHF_XM06hUk_Z_an6OS32Bl0B_AVQ4FGJZ-rtPjL5mNw/viewform?embedded=true"
          };
        case "lærer":
          return {
            height: 3700,
            url:
              "https://docs.google.com/forms/d/e/1FAIpQLSdSIZE7bXfcAWJh6kLjw9FS67n2ybREUtFrFPFz0FfUgctDuQ/viewform?embedded=true"
          };
      }
    }
  }
};
</script>
<style>
ul.iam {
  padding: 0;
}
ul.iam li {
  display: inline-block;
  margin: 10px;
}
ul.iam li a {
  display: block;
  background: #00ffd4;
  color: #000000;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
ul.iam li a.active {
  background: #ff00f9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/evaluering.vue